// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vf-z","col":"styles_col__MH0x-"};